
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'PreviewImage',
})
export default class PreviewImage extends Vue {
    /** 图片链接 */
    @Prop({ type: String }) public src?: string;

    public onClick() {
        if (this.src) {
            // 预览图片
            wx.previewImage({
                // 当前预览的图片http链接
                current: this.src,
                // 需要预览的图片http链接列表
                urls: [ this.src ],
            });
        }
    }
}
